import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosError, CancelTokenSource } from 'axios';
import { MiddlewareAPI, PROCEDA_API } from '../../../config/api';
import { IBadRequestResponse } from '../../../interfaces/IBadRequestResponse';
import {
  INotfis,
  INotfisResponse,
} from '../../../interfaces/response/Notfis/INotfisResponse';

export const postCheckOrder = createAsyncThunk(
  'rotas/postCheckOrder',
  async (
    args: {
      body: { nfKey: string; entrega: boolean };
      cancelToken: CancelTokenSource;
    },
    { rejectWithValue }
  ): Promise<INotfisResponse | any> => {
    const {
      cancelToken,
      body: { nfKey, entrega },
    } = args;

    try {
      const { data } = await MiddlewareAPI.get<INotfisResponse>(
        `/v1/Notfis/${nfKey}?entrega=${entrega}`,
        {
          cancelToken: cancelToken.token,
        }
      );
      return data;
    } catch (err) {
      const error = err as AxiosError<IBadRequestResponse>;

      return rejectWithValue(error);
    }
  }
);

export const postCheckFastOrder = createAsyncThunk(
  'rotas/postCheckFastOrder',
  async (
    args: {
      body: { nfKey: string; entrega: boolean };
      cancelToken: CancelTokenSource;
    },
    { rejectWithValue }
  ): Promise<INotfisResponse | any> => {
    const {
      cancelToken,
      body: { nfKey, entrega },
    } = args;

    try {
      const { data } = await MiddlewareAPI.get<INotfisResponse>(
        `/v1/Proceda/${nfKey}?entrega=${entrega}`,
        {
          cancelToken: cancelToken.token,
        }
      );
      return data;
    } catch (err) {
      const error = err as AxiosError<IBadRequestResponse>;

      return rejectWithValue(error);
    }
  }
);
export const ObterPedidos = createAsyncThunk(
  'clientsData/ObterPedidos',
  async (
    args: {
      dataInicio: string;
      dataFim: string;
    },
    { rejectWithValue }
  ): Promise<INotfisResponse | any> => {
    try {
      const query = new URLSearchParams({
        dataInicio: args.dataInicio,
        dataFim: args.dataFim,
      }).toString();

      const response = await MiddlewareAPI.get(`/v1/Notfis?${query}`);

      return response.data;
    } catch (err: any) {
      const error = err as AxiosError<IBadRequestResponse>;

      return rejectWithValue(error);
    }
  }
);

export const postUploadNotfis = createAsyncThunk(
  'rotas/uploadNotfis',
  async (
    args: {
      body: INotfis;
      cancelToken: CancelTokenSource;
    },
    { rejectWithValue }
  ): Promise<INotfisResponse | any> => {
    const { cancelToken } = args;

    try {
      const { data } = await MiddlewareAPI.post<INotfisResponse>(
        `/v1/Notfis`,
        args.body,
        {
          cancelToken: cancelToken.token,
        }
      );
      return data;
    } catch (err) {
      const error = err as AxiosError<IBadRequestResponse>;

      return rejectWithValue(error);
    }
  }
);

export const postUploadFast = createAsyncThunk(
  'rotas/postUploadFast',
  async (
    args: {
      body: {
        base64: string;
        fileName: string;
      };
      cancelToken: CancelTokenSource;
    },
    { rejectWithValue }
  ): Promise<INotfisResponse | any> => {
    const { cancelToken } = args;

    try {
      const { data } = await PROCEDA_API.post<{
        success: boolean;
        message: string;
      }>(`/v1/proceda`, args.body, {
        cancelToken: cancelToken.token,
      });
      return data;
    } catch (err) {
      const error = err as AxiosError<IBadRequestResponse>;

      return rejectWithValue(error);
    }
  }
);
